import ImageListsTodo from '../images/projects/todo.jpg'
import ImageDanielAdaro from '../images/projects/Pagina-Daniel.jpg'
import ImageGasolinera from '../images/projects/gasolinera.jpg'
import ImageDynamicForm from '../images/projects/dynamic.jpg'
import ImagePronostico from '../images/projects/Pronostico.jpg'
import ChakraImage from '../images/techs/chakra.png'
import CSSImage from '../images/techs/css.png'
import ReactBoostrapImage from '../images/techs/react-bootstrap.png'
import ReactRouterDomImage from '../images/techs/react-router-dom.png'
import SemanticImage from '../images/techs/semantic.png'
import ViteImage from '../images/techs/vite.png'
import ReactImage from '../images/techs/react.png'
import HTMLImage from '../images/techs/HTML.png'
import JavaScriptImage from '../images/techs/Javascript.png'

export const projectsPortfolio = [
  {
    title: "Pronostico",
    image: ImagePronostico,
    techs: [
      { name: "HTML", src: HTMLImage },
      { name: "CSS", src: CSSImage },
      { name: "JavaScript", src: JavaScriptImage }
    ],
    description:
      "Application created with HTML, CSS and JavaScript to make a request an external API of Weather API.",
    repository: "https://github.com/facuadaro/App-Clima",
    website: "https://pronosticoarpc.netlify.app/",
  },
  {
    title: "Daniel Adaro",
    image: ImageDanielAdaro,
    techs: [
      { name: "React", src: ReactImage },
      { name: "CSS", src: CSSImage }
    ],
    description: "Tribute page to my brother, still in development.",
    repository: "https://github.com/facuadaro/Daniel-Adaro",
    website: "https://danieladaro.netlify.app/"
  },
  {
    title: "Lists Todo",
    image: ImageListsTodo,
    techs: [
      { name: "React", src: ReactImage },
      { name: "Semantic UI React", src: SemanticImage }
    ],
    description: "Aplication created with React JS and Semantic UI to make a list of tasks where you can add or remove it",
    repository: "https://github.com/facuadaro/App-Tareas",
    website: "https://arpctareas.netlify.app/"
  },
  {
    title: "Dynamic Form",
    image: ImageDynamicForm,
    techs: [
      { name: "React JS", src: ReactImage },
      { name: "React Bootstrap", src: ReactBoostrapImage },
    ],
    description:
      "Application of a landing page created with React JS and React Bootstrap to make a form with dynamic fields.",
    repository: "https://github.com/facuadaro/Dynamic-Form",
    website: "https://arpcdynamicform.netlify.app/",
  },
  {
    title: "Fuel Station",
    image: ImageGasolinera,
    techs: [
      { name: "Vite", src: ViteImage },
      { name: "Chakra", src: ChakraImage },
      { name: "React Router DOM", src: ReactRouterDomImage },
    ],
    description:
      "Application created with Vite where you can save the information and see it on a summary",
    repository: "https://github.com/facuadaro/fuel-station-app",
    website: "https://gasolineraarpc.netlify.app",
  },
]